module.exports = __webpack_public_path__ + "static/img/29057806.74b87e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/29057806.jpg
// module id = xEpH
// module chunks = 0